"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileVersion = void 0;
exports.fileVersion = {
    v1: {
        headerRowRange: 'A14:AA14',
    },
    v2: {
        headerRowRange: 'A1:AA1',
    },
};
